import { NodeEnum, type NodeDefault } from '../../types';
import { SemanticRulesExtractionNodeType } from './types';

const nodeDefault: NodeDefault<SemanticRulesExtractionNodeType> = {
  author: 'PIKA',
  about: '语义规则抽取节点',
  icon: 'icon-video_fill_light',
  color: '#2E90FA',
  defaultData: {
    type: NodeEnum.SemanticRulesExtraction,
    name: '语义规则抽取节点',
    title: '语义规则抽取节点',

  },
  name: '语义规则抽取节点',

//   description: `定义一个 Chatflow 流程中的回复内容。
// 你可以在文本编辑器中自由定义回复格式，包括自定义一段固定的文本内容、使用前置步骤中的输出变量作为回复内容、或者将自定义文本与变量组合后回复。`,
  getAvailablePrevNodes() {
    return [];
  },
  getAvailableNextNodes() {
    return [];
  },
  checkValid() {
    return {
      isValid: true,
    };
  },
};

export default nodeDefault;

